import { defineComponent as _defineComponent } from 'vue'
import PaymentListing from 'ah-payments/src/components/PaymentListing.vue';
import PaymentsListFilters from './PaymentsListFilters.vue';
import ListBlock from 'ah-common-lib/src/common/components/listing/ListBlock.vue';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { ExportListType, PaginatedParams, PaymentType } from 'ah-api-gateways';
import { computed, reactive, ref, watch } from 'vue';
import { paymentsTableFields } from './tableFields/paymentsTableFields';
import { RequestState } from 'ah-requests';
import { useAuthStore } from '@/app/store/authStore';
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useAggregatedPaymentLinkCheck } from 'ah-trades/src/composables/aggregatedPaymentLimitChecker';
import { throwError } from 'rxjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsListBlock',
  props: {
    showExport: { type: [Boolean, String], default: true }
  },
  setup(__props: any, { expose }) {



const paymentListing = ref<InstanceType<typeof PaymentListing> | null>(null);

const authStore = useAuthStore();

const router = useRouter();

const route = useRoute();

const commonFilters = computed(() => ({
  partnerId: authStore.loggedInIdentity?.partner.id,
  clientId: authStore.loggedInIdentity?.client?.id,
  excludeClients: !authStore.isClientUser,
}));

const state = reactive<{
  // Automatically syncronised via .sync
  dataDownloadState: RequestState;
  pageAndSortParams: Partial<PaginatedParams>;
}>({
  dataDownloadState: 'idle',
  pageAndSortParams: { sort: 'createdAt', sortDirection: 'DESC' },
});

const config = computed(() => {
  return {
    tableFields: paymentsTableFields,
  };
});

function downloadList(format: ExportListType, options: { [key: string]: any }) {
  paymentListing.value?.downloadData(format, options);
}

function loadData() {
  paymentListing.value?.loadData();
}

const pageOptions = ref([
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
]);

/**
 * Logic for handling links coming from aggregated limit warnings
 *
 * Accepts the query string `forAggregatedReview`, will remove it and return state accordingly
 */
watch(
  () => route.query,
  () =>
    useAggregatedPaymentLinkCheck(router)
      .then(() =>
        setTimeout(() => {
          paymentListing.value?.loadData({ type: [PaymentType.SCHEDULED, PaymentType.TRADE_SEND_TO_BENEFICIARY] });
        })
      )
      .catch(() => throwError('Query param forAggregatedReview not found')),
  { immediate: true }
);

expose({ loadData: loadData });

return { __sfc: true,paymentListing, authStore, router, route, commonFilters, state, config, downloadList, loadData, pageOptions, PaymentListing, PaymentsListFilters, ListBlock, ListDownloadButton, SizeSelector }
}

})